module.exports = __webpack_public_path__ + "img/7.e81380d4.png";